exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delivery-note-create-page .item-table .item-body .item-row td[data-v-ae10c4ce] {\n  padding-left: 0px !important;\n}\n", ""]);

// exports
